var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/GTechIssueTemplate.ts";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { Assignee } from './Assignee';
import { Attribute } from './Attribute';
import { ApiDomain } from './domain';
export var GTechIssueTemplate;
(function (_GTechIssueTemplate) {
  var domain = ApiDomain.domain('GTechIssueTemplate', {
    name: "domain",
    sid: "-v2ril0"
  });
  var SortableField;
  (function (SortableField) {
    SortableField["name"] = "name";
    SortableField["description"] = "description";
    SortableField["createdAt"] = "createdAt";
    SortableField["updatedAt"] = "updatedAt";
    SortableField["id"] = "id";
  })(SortableField || (SortableField = {}));
  _GTechIssueTemplate.SortableField = SortableField;
  var type = 'IssueTemplate';
  var IssueTemplate = _GTechIssueTemplate.IssueTemplate = t.intersection([t.type({
    type: t.literal(type),
    id: t.number,
    name: t.string,
    daysToDeadline: t.union([t.number, t["null"]]),
    version: t.number,
    deleted: t["boolean"],
    readOnly: t["boolean"],
    createdAt: t.union([t.string, t.undefined]),
    updatedAt: t.union([t.string, t.undefined]),
    projectUrn: t.string,
    authorId: t.union([t.string, t["null"]]),
    assignees: t.array(Assignee),
    attributes: t.array(Attribute)
  }), t.partial({
    description: t.union([t.string, t["null"]])
  })]);
  var Data = _GTechIssueTemplate.Data = t.type({
    list: t.array(IssueTemplate),
    total: t.number
  });
  var fetchList = _GTechIssueTemplate.fetchList = ApiCallService.create({
    name: 'fetchList',
    parentDomain: domain,
    result: Data,
    getKey: ['limit', 'offset', 'filter', 'projectUrn']
  });
  var FetchAllowedFiltersResponse = _GTechIssueTemplate.FetchAllowedFiltersResponse = t.type({
    assignees: t.array(Assignee),
    authorIds: t.array(t.string),
    attributeValueIds: t.array(t.number),
    createdDateRange: t.union([t.tuple([t.string, t.string]), t["null"]]),
    updatedDateRange: t.union([t.tuple([t.string, t.string]), t["null"]])
  });
  var fetchAllowedFilters = _GTechIssueTemplate.fetchAllowedFilters = ApiCallService.create({
    name: 'fetchAllowedFilters',
    parentDomain: domain,
    result: FetchAllowedFiltersResponse,
    getKey: ['projectUrn']
  });
  var fetch = _GTechIssueTemplate.fetch = ApiCallService.create({
    name: 'fetch',
    parentDomain: domain,
    result: IssueTemplate,
    getKey: ['id', 'version']
  });
  var fetchMostRecent = _GTechIssueTemplate.fetchMostRecent = ApiCallService.create({
    name: 'fetchMostRecent',
    parentDomain: domain,
    result: IssueTemplate,
    getKey: ['id']
  });
  var update = _GTechIssueTemplate.update = ApiCallService.create({
    name: 'update',
    parentDomain: domain,
    result: IssueTemplate,
    getKey: ['id', 'version', 'description', 'name', 'daysToDeadline']
  });
  var create = _GTechIssueTemplate.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: IssueTemplate,
    getKey: ['description', 'name', 'projectUrn', 'daysToDeadline']
  });
  var remove = _GTechIssueTemplate.remove = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: IssueTemplate,
    getKey: ['id', 'version']
  });
})(GTechIssueTemplate || (GTechIssueTemplate = {}));